import { CmsCta } from './CmsCta';
export { Collection as collection } from './Collection/Collection';
export { ExperimentVariation as experimentvariation } from './ExperimentVariation/ExperimentVariation';
export { CmsHeading as heading } from './CmsHeading/CmsHeading';
export { HeroV2Container as hero } from './HeroV2/HeroV2Container';
export { CmsLayout as layout } from './CmsLayout/CmsLayout';
export { LeadGen as leadgen } from './LeadGen/LeadGen';
export { PlanSelectionContainer as plans } from './PlanSelection/PlanSelectionContainer';
export { CmsSection as section } from './CmsSection/CmsSection';
export { StaticModule as staticmodule } from './StaticModule/StaticModule';
export { CmsText as text } from './CmsText/CmsText';
export { Tile as tile } from './Tile/Tile';
export { UserQuoteContainer as userquote } from './UserQuote/UserQuoteContainer';
export { VisitableVenues as visitablevenues } from './VisitableVenues/VisitableVenues';
export { CitcatLinks as citcatcities } from './CitcatLinks/CitcatLinks';
export { ComparePricing as comparepricing } from './ComparePricing/ComparePricing';
export { Faq as faq } from './Faq/Faq';
export { InviteAFriendHero as inviteafriendhero } from './InviteAFriendHero/InviteAFriendHero';
export { Benefits as membershipbenefits } from './Benefits/Benefits';
export { Picture as picture } from './Picture/Picture';
export { Press as press } from './Press/Press';
export { ProductGroupContainer as productcard } from './ProductGroup/ProductGroupContainer';
export { ProductTourTeaser as producttourteaser } from './ProductTourTeaser/ProductTourTeaser';
export { Template as templatemodule } from './Template/Template';
export { Testimonials as testimonials } from './Testimonials/Testimonials'; // CMS CTA Types

export var calltoaction = CmsCta;
export var ctaoffercheckout = CmsCta;
export var ctareferafriend = CmsCta;
export var ctayoutubevideo = CmsCta;